import DayScreenTheme from './theme/DayScreenTheme';
export default {
  Toyota: {
    Day: { ...DayScreenTheme },
  },
};
